import React, {useState,useEffect} from 'react'
import firebase from '../../../firebase'
import numeral from 'numeral'
import moment from 'moment'
import _ from 'lodash'

const Item = (props) => {
    const {data} = props
    const filtered = props.moves.slice(0,Number(props.index) + 1);
    const totalIncomes = _.reduce(filtered, (sum,n) => {
        if (n.type === 'Ingreso') {
            return sum + n.amount
        }
        return sum
    },0)
    const totalExpenses = _.reduce(filtered, (sum,n) => {
        if (n.type === 'Egreso') {
            return sum + n.amount
        }
        return sum
    },0)
    const balance = props.totalBefore + totalIncomes - totalExpenses

    return (
        <tr>
            <td>{moment(data.date).format('DD-MM-YYYY')}</td>
            <td>{data.payway}</td>
            <td>{data.brandName}</td>
            <td>{data.holderName}</td>
            <td>{data.concept}</td>
            <td>{data.type === 'Ingreso' ? numeral(data.amount).format('$0,0.00') : ''}</td>
            <td>{data.type === 'Egreso' ? numeral(data.amount).format('$0,0.00') : ''}</td>
            <td>{numeral(balance).format('$0,0.00')}</td>
        </tr>
    )
}

const AccountingBalanceContainer = (props) => {
    
    const [moves,setmoves] = useState([])
    const [before,setbefore] = useState([])

    useEffect(() => {
        const initialMonth = moment(props.month).startOf('month').valueOf()
        const endMonth = moment(props.month).endOf('month').valueOf()

        if (initialMonth && endMonth) {
            const getIncomes = new Promise((resolve) => {
                firebase.getCollectionRealTime('incomes').where('date','<=',endMonth).where('date','>=',initialMonth).onSnapshot(snap => {
                    var data = []
                    snap.docs.forEach(doc => {
                        var item = doc.data()
                        item.type = 'Ingreso'
                        data.push(item)
                    })
                    resolve(data)
                })
            })
            const getExpenses = (list) => {
                return new Promise ((resolve) => {
                    firebase.getCollectionRealTime('expenses').where('date','<=',endMonth).where('date','>=',initialMonth).onSnapshot(snap => {
                        snap.docs.forEach(doc => {
                            var item = doc.data()
                            item.type = 'Egreso'
                            list.push(item)
                        })
                        resolve(list)
                    })
                })
            }
            getIncomes.then(incomes => {
                getExpenses(incomes).then(list => {
                    setmoves(_.orderBy(list, ['date'],['asc']))
                })
            })
            const beforeIncomes = new Promise((resolve) => {
                firebase.getCollectionRealTime('incomes').where('date','<=',initialMonth-1).onSnapshot(snap => {
                    var data = []
                    snap.docs.forEach(doc => {
                        var item = doc.data()
                        item.type = 'Ingreso'
                        data.push(item)
                    })
                    resolve(data)
                })
            })
            const beforeExpenses = (list) => {
                return new Promise ((resolve) => {
                    firebase.getCollectionRealTime('expenses').where('date','<=',initialMonth-1).onSnapshot(snap => {
                        snap.docs.forEach(doc => {
                            var item = doc.data()
                            item.type = 'Egreso'
                            list.push(item)
                        })
                        resolve(list)
                    })
                })
            }
            beforeIncomes.then(incomes => {
                beforeExpenses(incomes).then(list => {
                    setbefore(list)
                })
            })
        }
    }, [props.month])

    const filterBrandBefore = props.selectedBrand ? _.filter(before, o => {
        return o.brandName === props.selectedBrand
    }) : before
    const filteredBefore = props.filter ? _.filter(filterBrandBefore, o => {
        return props.filter === 'bank' ? o.payway !== 'Efectivo' : o.payway === 'Efectivo'
    }) : filterBrandBefore


    const filterBrand = props.selectedBrand ? _.filter(moves, o => {
        return o.brandName === props.selectedBrand
    }) : moves
    const filtered = props.filter ? _.filter(filterBrand, o => {
        return props.filter === 'bank' ? o.payway !== 'Efectivo' : o.payway === 'Efectivo'
    }) : filterBrand


    const totalBeforeIncomes = _.reduce(filteredBefore, (sum,n) => {
        if (n.type === 'Ingreso') {
            return sum + n.amount
        }
        return sum
    },0)
    const totalBeforeExpenses = _.reduce(filteredBefore, (sum,n) => {
        if (n.type === 'Egreso') {
            return sum + n.amount
        }
        return sum
    },0)
    const totalBefore = totalBeforeIncomes - totalBeforeExpenses

    const totalIncomes = _.reduce(filtered, (sum,n) => {
        if (n.type === 'Ingreso') {
            return sum + n.amount
        }
        return sum
    },0)
    const totalExpenses = _.reduce(filtered, (sum,n) => {
        if (n.type === 'Egreso') {
            return sum + n.amount
        }
        return sum
    },0)
    const total = totalIncomes - totalExpenses

    return (
        <tbody>
            <tr>
                <th colSpan="2">Saldo Inicial: {numeral(totalBefore).format('$0,0.00')}</th>
                <th colSpan="5"></th>
                <th colSpan="2">Saldo Final: {numeral(totalBefore + total).format('$0,0.00')}</th>
            </tr>
            <tr>
                <th>Fecha</th>
                <th>Forma de Pago</th>
                <th>Marca</th>
                <th>Cliente / Proveedor</th>
                <th>Concepto</th>
                <th>Ingresos</th>
                <th>Egresos</th>
                <th>Balance</th>
            </tr>
            {
                Object.keys(filtered).map(key => <Item key={key} index={key} moves={filtered} totalBefore={totalBefore} data={filtered[key]} />)
            }
        </tbody>
    )

}

const AccountingBalance = () => {

    const [month,setMonth] = useState(undefined)
    const [brands,setBrands] = useState([])
    const [selectedBrand,setSelectedBrand] = useState(undefined)
    const [filter,setFilter] = useState(undefined)

    useEffect(() => {
        firebase.getCollectionOnce('brands').then(snap => {
            const brands = snap.docs.map(doc => doc.data())
            setBrands(brands)
        })
        const current = moment().format('MM-YYYY')
        setMonth(current)
    }, [])

    return (
        <div className="accounting-balance">
            <ul className="accounting-balance__filter">
                <li className={selectedBrand === undefined ? 'active': ''} onClick={() => setSelectedBrand(undefined)}>Todas las Marcas</li>
                {
                    Object.keys(brands).map(key => <li className={selectedBrand === brands[key].name ? 'active' : ''} key={key} onClick={() => setSelectedBrand(brands[key].name)}>{brands[key].name}</li>)
                }
            </ul>
            <ul className="accounting-balance__filter">
                <li className={filter === undefined ? 'active': ''} onClick={() => setFilter(undefined)}>Todos las Movimientos</li>
                <li className={filter === 'bank' ? 'active': ''} onClick={() => setFilter('bank')}>Bancos</li>
                <li className={filter === 'cash' ? 'active': ''} onClick={() => setFilter('cash')}>Efectivo</li>
            </ul>
            <table>
                <thead>
                    <tr>
                        <th colSpan="9">
                            <div className="date-picker">
                                <button onClick={prevMonth}>
                                    <i className="material-icons">arrow_left</i>
                                </button>
                                <span>{month}</span>
                                <button onClick={nextMonth}>
                                    <i className="material-icons">arrow_right</i>
                                </button>
                            </div>
                        </th>
                    </tr>
                </thead>
                <AccountingBalanceContainer filter={filter} selectedBrand={selectedBrand} month={moment(month,'MM-YYYY').valueOf()} />
            </table>
        </div>
    )

    async function nextMonth() {
        try {
            const newMonth = moment(month, 'MM-YYYY').add(1,'month').format('MM-YYYY')
            setMonth(newMonth)
        } catch (error) {
            alert(error.message)
        }
    }
    async function prevMonth() {
        try {
            const newMonth = moment(month, 'MM-YYYY').subtract(1,'month').format('MM-YYYY')
            setMonth(newMonth)
        } catch (error) {
            alert(error.message)
        }
    }
}

export default AccountingBalance